import React, { ReactElement } from 'react'
import { UBOManager } from './ubo/uboManager'
import { OnboardingPageProps } from './onboardingManager'
import { isReleased } from 'utilities'
import { OwnershipComponent } from './ownersComponents'

export const UBOOwnerManager = ({
  onNext,
  validate,
  handleFieldChange,
  activeClient,
  setCurrentPage,
  formRef,
  setServerErrors,
  setSteps,
  clientOnboarding,
  processingClientOnboarding,
}: OnboardingPageProps): ReactElement => {
  if (isReleased('rot_2548_ubo_released'))
    return (
      <UBOManager
        onNext={onNext}
        validate={validate}
        handleFieldChange={handleFieldChange}
        activeClient={activeClient}
        setCurrentPage={setCurrentPage}
        formRef={formRef}
        setServerErrors={setServerErrors}
        setSteps={setSteps}
        clientOnboarding={clientOnboarding}
        processingClientOnboarding={processingClientOnboarding}
      />
    )
  return (
    <OwnershipComponent
      onNext={onNext}
      validate={validate}
      handleFieldChange={handleFieldChange}
      activeClient={activeClient}
      setCurrentPage={setCurrentPage}
      formRef={formRef}
      setServerErrors={setServerErrors}
      setSteps={setSteps}
      clientOnboarding={clientOnboarding}
      processingClientOnboarding={processingClientOnboarding}
    />
  )
}
